import { memo, useMemo } from 'react';
import MyProfileSection from './MyProfileSection/MyProfileSection';
import { getLoginInformationInitialState } from './MyProfileSection/MyProfileSection.utils';
import { useSelector } from '@betty/toolkit/state';
import { selectAccount } from '../../state';

function LoginInfo() {
  const account = useSelector(selectAccount);
  const fieldData = useMemo(
    () => getLoginInformationInitialState(account),
    [account],
  );

  return (
    <MyProfileSection
      fieldData={fieldData}
      disableEditing
      titleLocKey="myProfileLoginTitle"
    />
  );
}

export default memo(LoginInfo);
